import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  templateUrl: './app.html',
})
export class App implements OnInit {
  private readonly title: Title = inject(Title);
  private readonly transloco: TranslocoService = inject(TranslocoService);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.transloco
      .selectTranslate('layout.document_title')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: string): void => this.title.setTitle(value));
  }
}
